import Immutable from 'immutable';
import { OFFSET } from '../../utils/constants';

const LOAD = 'contact/LOAD';
const LOAD_SUCCESS = 'contact/LOAD_SUCCESS';
const LOAD_FAIL = 'contact/LOAD_FAIL';
const LOAD_ADD_SUCCESS = 'contact/LOAD_ADD_SUCCESS';

const PDFFILEUPLOADS_LOAD = 'contact/PDFFILEUPLOADS_LOAD';
const PDFFILEUPLOADS_LOAD_SUCCESS = 'contact/PDFFILEUPLOADS_LOAD_SUCCESS';
const PDFFILEUPLOADS_LOAD_FAIL = 'contact/PDFFILEUPLOADS_LOAD_FAIL';

const initialState = Immutable.fromJS({
  Contacts: null,
  loading: false,
  errorMessage: null,
  activePage: 1
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('loading', true);

    case LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('activePage', action.page)
    .set('Contacts', action.Contacts);

    case LOAD_ADD_SUCCESS:
    return state
    .set('loading', false)
    .set('Contact', action.result);

    case PDFFILEUPLOADS_LOAD:
    return state
    .set('loading', true);

    case PDFFILEUPLOADS_LOAD_FAIL:
    return state
    .set('loading', false)
    .set('errorMessage', action.errorMessage);

    case PDFFILEUPLOADS_LOAD_SUCCESS:
    return state
    .set('loading', false)
    .set('pdfFileUploads', action.pdfFileUploads);

    default:
    return state;
  }
}

export const getContact = (offset, page ) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  if (!page) {
    const Contacts = getState().get('contact').get('Contacts');
    page = Math.ceil(Contacts.count / OFFSET);
    offset = OFFSET * (page - 1)
  }
  try {
    const res = await api.get(`/contact/${offset}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Contacts: res, page: page });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getContactById = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/contact/conactGetById/' + id );
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const addContact = (data) => async (dispatch, getState, api) => {
  const activePage = getState().get('contact').get('activePage');
  let offset = OFFSET * (activePage - 1);
  dispatch({ type: LOAD });
  try {

    const res = await api.post('/contact', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getContact(offset));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const updateContact = (data) => async (dispatch, getState, api) => {
  const activePage = getState().get('contact').get('activePage');
  let offset = OFFSET * (activePage - 1);
  dispatch({ type: LOAD });
  try {

    const res = await api.put('/contact', { data });

    if (res.message) {
      dispatch(getContact(offset, activePage));
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const deleteContact = (data, offset) => async (dispatch, getState, api) => {
  const activePage = getState().get('contact').get('activePage');
  dispatch({ type: LOAD });
  try {

    const res = await api.del('/contact', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getContact(offset, activePage));
    dispatch({ type: LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const sortByGroup = (data) => async (dispatch, getState, api) => {
  let page = data.page;
  dispatch({ type: LOAD });
  if (!page) {
    const Contacts = getState().get('contact').get('Contacts');
    page = Math.ceil(Contacts.count / OFFSET);
  }
  try {

    const res = await api.put('/contact/sortByGroup', { data });

    if (res.message) {
      dispatch(getContact());
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Contacts: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const generateContactsPdf = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {

    const res = await api.put('/contact/generateContactsPdf', { data });

    if (res.message) {
      dispatch(getContact());
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;

  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};


export const uploadContact = (data) => async (dispatch, getState, api) => {
  const activePage = getState().get('contact').get('activePage');
  let offset = OFFSET * (activePage - 1);
  dispatch({ type: LOAD });
  try {

    const res = await api.post('/uploadContact', { data });

    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch(getContact(offset));
    dispatch({ type: LOAD_ADD_SUCCESS, result: res });
    return res;
  } catch (error) {

    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * User pre-signed in
 */

export const pdfFilesDetail = (data) => async (dispatch, getState, api) => {

  dispatch({ type: PDFFILEUPLOADS_LOAD });
  try {
    const res = await api.put('/contact/pdfFile/', { data });
    if (res.message) {
      dispatch({ type: PDFFILEUPLOADS_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: PDFFILEUPLOADS_LOAD_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: PDFFILEUPLOADS_LOAD_FAIL, errorMessage: error.message || error });
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/contact.js